import React from "react";

function Electronics() {
  return <div>
    <h2>This is my electronics page</h2>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi illum nihil debitis porro corrupti! Culpa, deserunt nihil! Mollitia laborum natus autem omnis! Doloribus maiores facilis eum quam, accusamus expedita incidunt!</p>
  </div>;
}

export default Electronics;
